export class LanguageKeysTH {
  public MESSAGES = ({ count }: { count: number; }) => {
    return count === 1 ? `${count} Message` : `${count} Messages`;
  };

  public Page = 'หน้า';
  public GoTo = 'ไปที่';
  public PerPage = '/ หน้า';
  public Logout = 'ออกจากระบบ';
  public Cancel = "ยกเลิก";
  public Close = 'ปิด';
  public Add = 'เพิ่ม';

  public UploadImage = 'อัปโหลดรูป'
}

export type LangProps = keyof LanguageKeysTH;
export default LanguageKeysTH;
